import React from 'react';

function WinPopup({ winningAmount, t, currencyCode }) {
  return (
    <div className='winning-popup'>
      <div className='winning-popup-body'>
        <h4 className='winning-popup-title'>{t('YOU_WIN')}</h4>
        <p className='winning-popup-price'>
          {winningAmount}
          {currencyCode}
        </p>
      </div>
    </div>
  );
}

export default WinPopup;
